export interface MerchantBillingProfile {
  billing_cycle_start?: string | null;
  billing_provider?: string | null;
  platform_type?: string | null;
  signup_source?: string | null;
  splits_this_month?: number | null;
}

export type MerchantBillingChannel = "shopify_app_store" | "wallet";

const BILLING_CYCLE_MS = 30 * 24 * 60 * 60 * 1000;

export function getMerchantBillingChannel(merchant: MerchantBillingProfile | null | undefined): MerchantBillingChannel {
  if (!merchant) {
    return "wallet";
  }

  if (merchant.billing_provider === "razorpay") {
    return "wallet";
  }

  if (merchant.platform_type === "woocommerce") {
    return "wallet";
  }

  const signupSource = (merchant.signup_source || "").trim().toLowerCase();
  return signupSource === "shopify_app_store" ? "shopify_app_store" : "wallet";
}

export function usesWalletBillingForMerchant(merchant: MerchantBillingProfile | null | undefined): boolean {
  return getMerchantBillingChannel(merchant) === "wallet";
}

export function getCompletedSplitsInCurrentBillingCycle(
  merchant: Pick<MerchantBillingProfile, "billing_cycle_start" | "splits_this_month"> | null | undefined,
  now = new Date(),
): number {
  if (!merchant) {
    return 0;
  }

  const rawCount = Number(merchant.splits_this_month) || 0;
  const cycleStart = merchant.billing_cycle_start ? new Date(merchant.billing_cycle_start) : null;

  if (!cycleStart || Number.isNaN(cycleStart.getTime())) {
    return rawCount;
  }

  if (now.getTime() - cycleStart.getTime() >= BILLING_CYCLE_MS) {
    return 0;
  }

  return rawCount;
}
